 
export const PREFIX_API = "cuadromando";
export const INDICADOR_TIPO_ESTRATEGICO_ID = 1;
export const INDICADOR_TIPO_OPERATIVO_ID = 2;
export const INDICADOR_TIPO_ESTRATEGICO_NAME = "Estrategico"
export const INDICADOR_TIPO_OPERATIVO_NAME = "Operativo"

export const FORMAT_DATE = "YYYY-MM"; 

export const FUENTE_DE_INFORMACION_TIPO_CAPTURA = 1;
export const FUENTE_DE_INFORMACION_TIPO_FORMULA = 4;

export const OPERADORES_MATEMATICOS = ["(", ")", "+", "-", "*", "/"];
export const DIGITOS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
 
export const FORMATO_DE_VARIABLES_TIPO_MONEDA = 1;
export const FORMATO_DE_VARIABLES_TIPO_ENTERO = 2;
export const FORMATO_DE_VARIABLES_TIPO_PORCENTAJE = 3;
export const FORMATO_DE_VARIABLES_TIPO_REAL = 4;


export const CLASE_TIPO_VARIABLE = 1;
export const CLASE_TIPO_VALOR_ACTUAL = 2;
export const CLASE_TIPO_ALCANZADO = 3;
export const CLASE_TIPO_META = 4;
export const CLASE_TIPO_CONSTANTE = 5;


export const OBSERVACION_TIPO_ANALISIS = 'Análisis';
export const OBSERVACION_TIPO_RECOMENDACION = 'Recomendacion';

export const ORDENAMIENTO_POR_CMI = 1;
export const ORDENAMIENTO_POR_VALOR_ASC = 2;
export const ORDENAMIENTO_POR_VALOR_DESC = 3;
 
export const CATALOGO_ESTATUS_SEMAFORIZACION = {
  META_O_POR_ENCIMA_DE_LA_META: "M",
  PRECAUCION: "P",
  DEBAJO_DE_LA_META: "D",
  SIN_INFORMACION: "S",
  LIMITE_INFERIOR: "LI",
  LIMITE_SUPERIOR: "LS"
}

export const CATALOGO_ESTATUS = [
  {
    "id": '2',
    "data": "Todos",
  },
  {
    "id": '1',
    "data": "Activo",
  },
  {
    "id": '0',
    "data": "Inactivo",
  },
];
 

export const CATALOG_EVALUATION_INDICATOR = [
  {
    "id": 1,
    "estatus": CATALOGO_ESTATUS_SEMAFORIZACION.META_O_POR_ENCIMA_DE_LA_META,
    "descripcion": "Meta o por encima de la meta",
    "color": "#249E00"
  },
  {
    "id": 2,
    "estatus": CATALOGO_ESTATUS_SEMAFORIZACION.PRECAUCION,
    "descripcion": "Precaución",
    "color": "#F7FF02"
  },
  {
    "id": 3,
    "estatus": CATALOGO_ESTATUS_SEMAFORIZACION.DEBAJO_DE_LA_META,
    "descripcion": "Debajo de meta",
    "color": "#FA0202"
  },
  {
    "id": 4,
    "estatus": CATALOGO_ESTATUS_SEMAFORIZACION.SIN_INFORMACION,
    "descripcion": "Sin información",
    "color": "#0291FA"
  },
  {
    "id": 5,
    "estatus": CATALOGO_ESTATUS_SEMAFORIZACION.LIMITE_INFERIOR,
    "descripcion": "Comenzar en:",
    "color": ""
  },
  {
    "id": 6,
    "estatus": CATALOGO_ESTATUS_SEMAFORIZACION.LIMITE_SUPERIOR,
    "descripcion": "Finalizar en:",
    "color": ""
  },
];

export const CATALOGO_DE_TIPOS_DE_INDICADORES = [
  {
    "id": INDICADOR_TIPO_ESTRATEGICO_ID,
    "data": INDICADOR_TIPO_ESTRATEGICO_NAME
  },
  {
    "id": INDICADOR_TIPO_OPERATIVO_ID,
    "data": INDICADOR_TIPO_OPERATIVO_NAME
  },
];

export const FUENTE_DE_INFORMACION_DE_VARIABLES = [
  {
    "id": FUENTE_DE_INFORMACION_TIPO_CAPTURA,
    "data": "Captura"
  },
  {
    "id": 2,
    "data": "Acumulado de los contribuidores"
  },
  {
    "id": 3,
    "data": "Promedio de los contribuidores"
  },
  {
    "id": FUENTE_DE_INFORMACION_TIPO_FORMULA,
    "data": "Calculado con fórmula"
  }
]


export const FORMATO_DE_VARIABLES = [
  {
    "id": FORMATO_DE_VARIABLES_TIPO_MONEDA,
    "data": "Moneda"
  },
  {
    "id": FORMATO_DE_VARIABLES_TIPO_ENTERO,
    "data": "Número entero"
  },
  {
    "id": FORMATO_DE_VARIABLES_TIPO_PORCENTAJE,
    "data": "Porcentaje"
  },
  {
    "id": FORMATO_DE_VARIABLES_TIPO_REAL,
    "data": "Real"
  }
];


export const CATALOGO_DE_CLASES_DE_VARIABLES = [
  {
    "id": CLASE_TIPO_VARIABLE,
    "data": "Variable",
    "prioridad_evaluacion": 1
  },
  {
    "id": CLASE_TIPO_CONSTANTE,
    "data": "Constante",
    "prioridad_evaluacion": 2
  },
  {
    "id": CLASE_TIPO_VALOR_ACTUAL,
    "data": "Actual valor del indicador",
    "prioridad_evaluacion": 4
  },
  {
    "id": CLASE_TIPO_ALCANZADO,
    "data": "Alcanzado, aplica para evaluación",
    "prioridad_evaluacion": 5
  },
  {
    "id": CLASE_TIPO_META,
    "data": "Meta",
    "prioridad_evaluacion": 3
  }
]

export const OPERADORES_DE_COMPARACION = [
  {
    "id": '<',
    "data": '<'
  },
  {
    "id": '<=',
    "data": '<='
  },
  {
    "id": '>',
    "data": '>'
  },
  {
    "id": '>=',
    "data": '>='
  },
  {
    "id": '<>',
    "data": '<>'
  },
  {
    "id": '=',
    "data": '='
  }
]

export const CATALOGO_DE_PERIODOS_TIEMPO = [
  {
    id: 1,
    data: "Mensual"
  },
  {
    id: 2,
    data: "Bimestral"
  },
  {
    id: 3,
    data: "Trimestral"
  },
  {
    id: 4,
    data: "Cuatrimestral"
  },
  {
    id: 6,
    data: "Semestral"
  },
  {
    id: 12,
    data: "Anual"
  }
];

export  const CATALOGO_ORDENAMIENTO_DE_CONTRIBUIDORES = [
    {
        "id": ORDENAMIENTO_POR_CMI,
        "data": "Alfabeticamente por CMI",
    },
    {
        "id": ORDENAMIENTO_POR_VALOR_DESC,
        "data": "Mayor a menor",
    },
    {
        "id": ORDENAMIENTO_POR_VALOR_ASC,
        "data": "Menor a mayor",
    }
];